import { FilterField } from 'coreOld/enums';

export const filtersConfig = [
  {
    name: 'query',
    type: FilterField.SEARCH,
    flex: 100,
  },
];
